import React, { useEffect, useState, useContext } from 'react';
import Select, { components } from 'react-select';
import { getSetupColor } from '../utils/LMConstants';
import { SelectSessionSetup, CheckSessionSetup, CheckAllSessionSetup, GetCurrentSession } from '../isdlData/sessionData';
import { ViewOnlyContext } from '../contexts/AppContext';
import { session_update } from '../mobile/mobileHandler';



function SetupsCombo({ currentSession, setCurrentSetup, Disabled, Refresh }) {

    const [selectedSetup, setSelectedSetup] = useState(null);
    const [setups, setSetups] = useState([]);
    const menuPortalTarget = typeof document !== 'undefined' ? document.body : null;
     const { viewOnly } = useContext(ViewOnlyContext);
    
    useEffect(() => {

        if (currentSession && currentSession.SessionSetups && currentSession.SessionSetups.length > 0) {
            let curSetup = currentSession.SessionSetups.find(setup => setup.IsSelected);
            let curSetupIdx = currentSession.SessionSetups.findIndex(setup => setup.IsSelected);
            if (curSetup === undefined) {//could happen!
                curSetup = currentSession.SessionSetups[0];
                curSetupIdx = 0;
            }
            setSelectedSetup(
                {
                    ...curSetup,
                    bg: getSetupBg(curSetupIdx),
                    fg: getSetupFg(curSetupIdx)
                });
            setSetups(currentSession.SessionSetups.map((setup, index) => (
                {
                    value: setup.Id,
                    label: getSetupName(setup),
                    data:
                    {
                        ...setup,
                        bg: getSetupBg(index),
                        fg: getSetupFg(index)
                    }
                }
            )));
        }

    }, [currentSession]);

    function getSetupName(setup) {
        let clubString = "";
        if (setup.ClubName === "Prototype") {
            // clubString = setup.ClubId;
            if (setup.ClubDescription) {
                clubString = setup.ClubDescription;
            } else {
                clubString = setup.ClubId;
            }
        } else if (setup.ClubName === "Custom") {
            clubString = setup.ClubName + (setup.ClubId ? ` [${setup.ClubId}]` : "");
        } else {
            clubString = setup.ClubName;
        }

        let ballString = "";
        if (setup.BallName === "Prototype") {
            if (setup.Id === "Setup Series" || setup.Id.includes("Series ")) {
                clubString = null;
                ballString = setup.Id;
            } else {
                ballString = setup.BallName + !setup.BallPrototypeId ? "" : ("[" + setup.BallPrototypeId + "]");
            }
        } else if (setup.BallName === "Ball Series Testing") {
            if (setup.Id === "Setup Series" || setup.Id.includes("Series ")) {
                clubString = null;
                ballString = setup.Id;
            } else {
                ballString = setup.BallName + !setup.BallPrototypeId ? "" : ("[" + setup.BallPrototypeId + "]");
            }
        } else if (setup.BallName === "None") {
            ballString = "";
        } else {
            ballString = setup.BallName;
        }
        return (clubString ?? "") + ballString;
    }

    function getSetupBg(index) {
        return getSetupColor(currentSession?.SessionSetups?.[index], index).bg;
    }
    function getSetupFg(index) {
        return getSetupColor(currentSession?.SessionSetups?.[index], index).fg;
    }

    const CustomOption = (props) => (
        <components.Option {...props} style={{ padding: '0', margin: '0' }}>
            <div className='setup-combo-item-container'>
                <div className='setup-combo-item-color' style={{ backgroundColor: props.data.data.bg, color: props.data.data.fg,textAlign: "center" }}>
                    {props.data.data.LetterId}
                </div>
                <div className='setup-combo-item-text'>
                    {props.data.label}
                </div>
            </div>
        </components.Option>
    );
    const handleSetupSelect = async (e) => {
        const selectedId = e.value;
        setCurrentSetup(selectedId);

        const activeSession = GetCurrentSession() || currentSession;
        if (!activeSession || !activeSession.SessionSetups || activeSession.SessionSetups.length === 0) {
            return;
        }

        let curSetup = activeSession.SessionSetups.find(setup => setup.Id === selectedId);
        let curSetupIdx = activeSession.SessionSetups.findIndex(setup => setup.Id === selectedId);

        if (curSetup === undefined) {//could happen!
            curSetup = activeSession.SessionSetups[0];
            curSetupIdx = 0;
        }
        for (let i = 0; i < activeSession.SessionSetups.length; i++) {
            activeSession.SessionSetups[i].IsSelected = activeSession.SessionSetups[i].Id === curSetup.Id;
        }

        const updateDb = !viewOnly;

        try {
            await SelectSessionSetup(currentSession, curSetup, false);
            await CheckAllSessionSetup(false, false);
            await CheckSessionSetup(currentSession, curSetup, true, updateDb);
        } catch (error) {
            console.error('Error selecting setup from combo', error);
        }

        session_update(activeSession.id, curSetup.Id, viewOnly);
        setSelectedSetup(
            {
                ...curSetup,
                bg: getSetupBg(curSetupIdx),
                fg: getSetupFg(curSetupIdx)
            });
    };


    return (
        <div style={{ width: '400px', position: 'relative', zIndex:'200' }}>
             <div style={{ width: '400px', position: 'relative', zIndex:'200' }}></div>
            <Select
                options={setups}
                value={selectedSetup ? { value: selectedSetup.Id, label: getSetupName(selectedSetup), data: selectedSetup } : null}
                onChange={handleSetupSelect}
                isSearchable={false}
                menuShouldScrollIntoView={false}
                isDisabled={Disabled}
                menuPortalTarget={menuPortalTarget || undefined}
                menuPosition='fixed'
                components={{
                    Option: CustomOption,
                    SingleValue: CustomOption
                }}
                styles={{
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                    }),
                    input: (provided) => ({
                        ...provided,
                        color: 'transparent', // hide any text/cursor
                        background: 'transparent',
                        pointerEvents: 'none',        // so it doesn’t intercept clicks
                        margin: 0,
                        padding: 0,
                        width: '100%',        // full width so nothing shifts
                        height: '100%',        // full height as well
                    }),
                    control: (provided, state) => ({
                        ...provided,
                        padding: 1,
                        margin: 0,
                        minHeight: '44px',          // match your option height
                        height: '44px',             // fix the control height
                        // borderRadius: 0,            // square corners
                        // borderWidth: 0,             // remove default border
                        boxShadow: 'none',          // remove focus shadow
                        '&:hover': {                // no hover border either
                            borderColor: 'transparent',
                            boxShadow: 'none',
                        },
                        backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--background-tertiary'),
                    }),
                    valueContainer: (provided) => ({
                        ...provided,
                        display: 'flex',
                        flexDirection: 'column',
                        padding: 0,
                        margin: 0,
                        height: '40px',             // same here
                        boxSizing: 'border-box',
                    }),
                    menu: (provided) => ({
                        ...provided,
                        marginTop: 0,
                        padding: 0,           // remove its own padding
                        border: 'none',       // remove its border
                        boxShadow: 'none',    // remove its shadow
                        // borderRadius: 0,      // square it off
                    }),
                    menuList: (provided) => ({
                        ...provided,
                        padding: 0,      // no inner padding on the list
                    }),
                    singleValue: (provided) => ({
                        ...provided,
                        margin: 0,
                        width: '100%',
                        padding: 0,
                        lineHeight: '42px',         // vertically center your text
                    }),
                    option: (provided, state) => ({
                        ...provided,
                        margin: 0,       // remove any margins
                        padding: 1, // your desired padding
                        width: '100%',   // fill container
                        height: '42px'
                    }),
                    dropdownIndicator: (provided, state) => ({
                        ...provided,
                        color: state.isFocused ? getComputedStyle(document.documentElement).getPropertyValue('--foreground-primary') :
                            getComputedStyle(document.documentElement).getPropertyValue('--foreground-secondary'),
                        '&:hover': {
                            color: getComputedStyle(document.documentElement).getPropertyValue('--foreground-secondary'),
                        },
                    }),
                }} />
        </div>
    );
}
export default SetupsCombo;
